import type { FC } from 'react';
import { Flex } from './layouting';
import { Input } from './form/input/Input';

export const BackupCodesLayout: FC<{ backupCodes: string[] }> = ({ backupCodes }) => {
  const half = Math.ceil(backupCodes.length / 2);
  const left = backupCodes.slice(0, half);
  const right = backupCodes.slice(half);

  return (
    <Flex gap={24} justify="center">
      <Flex vertical gap={8}>
        {left.map(code => (
          <Input width={165} key={code} value={code} readOnly />
        ))}
      </Flex>

      <Flex vertical gap={8}>
        {right.map(code => (
          <Input width={165} key={code} value={code} readOnly />
        ))}
      </Flex>
    </Flex>
  );
};
